import { DatoContent } from "../DatoContent/DatoContent";
import { ViewStateWrapper } from "UIPalette/ViewStateWrapper/ViewStateWrapper";
import { useGetPublicPageFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import useLocale from "core/hooks/useLocale/useLocale";
import { useTranslation } from "react-i18next";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { PageHeader } from "UIPalette/PageHeader/PageHeader";
import { useNavigate } from "react-router-dom";
import { useNavBarContext } from "core/state/NavBarContext/NavBarContext";

type DatoContentPageProps = {
  slug: string | undefined;
  pageTitle?: string;
  title?: string;
  heading?: string;
};

export const DatoContentPage = ({ heading, slug, pageTitle, title }: DatoContentPageProps) => {
  useNavBarContext({ title });
  const { localeId } = useLocale();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data, isLoading, error, mutate } = useGetPublicPageFunctionRequest(
    {
      slug: slug,
      localeId,
    },
    { needsBearerToken: false, revalidateOnMountIfStale: false, showErrorIfStale: false }
  );

  if (!localeId) {
    return null;
  }

  return (
    <>
      <PageTitle title={pageTitle} />
      <PageHeader title={heading || data?.name} backTitle={t("datoContentPage.back")} onClickBack={() => navigate(-1)} hideForMobile />
      <ViewStateWrapper loading={isLoading} error={!!error} errorMessage={t("datoContentPage.error")} onRetry={mutate} isFullScreenView={true}>
        <div className="break-words">
          <DatoContent content={data?.content} />
        </div>
      </ViewStateWrapper>
    </>
  );
};
